// extracted by mini-css-extract-plugin
export default {"modal":"MessageTemplateManagementModal-module__modal__HfwRI","content":"MessageTemplateManagementModal-module__content__rGljb"};